exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".kubernetes-resize-stage .nested-label {\n  margin-left: 0;\n  margin-top: 7px;\n  padding: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/kubernetes/src/pipeline/stages/resizeAsg/resizeStage.less
// module id = 3818
// module chunks = 0